var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentModal,{tag:"component",attrs:{"modalProps":_vm.openModalProps}})}
var staticRenderFns = []

export { render, staticRenderFns }